import Swal from 'sweetalert2';
import { setSmallScreenStyles } from './set-small-screen-styles';
import axios from 'axios';
import { MAX_RETRY } from '@root/private/js/common/securekey/constants';
import { FRONTEND_MESSAGES } from '@root/private/js/lib/messages';

export const openPromptForKey = async (retryCount: number): Promise<string> => {
  const { value: passphrase } = await Swal.fire({
    title: FRONTEND_MESSAGES.passwordPromptTitle,
    text:
      retryCount === MAX_RETRY
        ? FRONTEND_MESSAGES.passwordPromptLabel
        : FRONTEND_MESSAGES.passwordPromptInvalid,
    iconColor: retryCount === MAX_RETRY ? '#4ab7ac' : '#f27474',
    iconHtml: '<i class="fa-solid fa-lock"></i>',
    confirmButtonText: FRONTEND_MESSAGES.confirm,
    input: 'text',
    allowEscapeKey: false,
    allowOutsideClick: false,
    confirmButtonColor: '#58c3bb',
    inputPlaceholder: FRONTEND_MESSAGES.passwordPromptPlaceholder,
    didRender: setSmallScreenStyles,
  });

  const { data } = await axios.post(`/pass`, { passphrase });
  return data;
};
